<template>
  <div class="base-bar-chart">
    <BaseDualBarChart
      v-for="item in data"
      :key="item.label"
      :label="item.label"
      :val1="item.val1"
      :val2="item.val2"
    />
  </div>
</template>

<script>
import BaseDualBarChart from '@/components/BaseDualBarChart/BaseDualBarChart'
export default {
  components: {
    BaseDualBarChart
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.base-bar-chart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
</style>
